module.exports = __webpack_public_path__ + "img/omil_mobile.22261090.png";